/**
 * @generated SignedSource<<cd16016ccdf57ca2c8675c9662720e15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTaskId_brandMessageExecutionsQuery$variables = {
  id: string;
};
export type BrandMessageTaskId_brandMessageExecutionsQuery$data = {
  readonly brandMessageExecutions: {
    readonly totalCount: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection">;
  };
};
export type BrandMessageTaskId_brandMessageExecutionsQuery = {
  response: BrandMessageTaskId_brandMessageExecutionsQuery$data;
  variables: BrandMessageTaskId_brandMessageExecutionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "taskId_Exact",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": {
      "executedAt": "DESC"
    }
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  },
  {
    "kind": "Literal",
    "name": "pageSize",
    "value": 10
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTaskId_brandMessageExecutionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageExecutionConnection",
        "kind": "LinkedField",
        "name": "brandMessageExecutions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTaskId_brandMessageExecutionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageExecutionConnection",
        "kind": "LinkedField",
        "name": "brandMessageExecutions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageExecutionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrandMessageExecution",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sequence",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "executedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "queriedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "targetCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveredFriendCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveredNormalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deliveredCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "failedCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sendFailedCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sendFailedPhoneNumbers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sendFailedVariables",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrandMessageTask",
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2461c396b6c3c9a329dc00ce0dbe172f",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTaskId_brandMessageExecutionsQuery",
    "operationKind": "query",
    "text": "query BrandMessageTaskId_brandMessageExecutionsQuery(\n  $id: ID!\n) {\n  brandMessageExecutions(filters: {taskId_Exact: $id}, order: {executedAt: DESC}, page: 0, pageSize: 10) {\n    totalCount\n    ...BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection\n  }\n}\n\nfragment BrandMessageExecutionConnectionDataTable_brandMessageExecutionConnection on BrandMessageExecutionConnection {\n  edges {\n    node {\n      id\n      sequence\n      created\n      executedAt\n      queriedAt\n      status\n      targetCount\n      deliveredFriendCount\n      deliveredNormalCount\n      deliveredCount\n      failedCount\n      sendFailedCount\n      sendFailedPhoneNumbers\n      sendFailedVariables\n      task {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad5f82e8664197c6c50c7d982e083af5";

export default node;
